import * as rtlDetect from 'rtl-detect';

export class LocalizedResourcesHelper {
    static loadResources(frontEndUrl: string, callback: () => void): void {
        $.when(
            LocalizedResourcesHelper.loadLocalizedStyles(frontEndUrl),
            LocalizedResourcesHelper.loadLocalizedScripts(frontEndUrl)
        ).done(() => {
            callback();
        });
    }

    private static loadLocalizedStyles(frontEndUrl: string): JQueryPromise<any> {
        let isRtl = rtlDetect.isRtlLang(abp.localization.currentLanguage.name);
        let cssPostfix = "";

        if (isRtl) {
            cssPostfix = "-rtl";
            $('html').attr("dir", "rtl");
        }

        //Bootstrap css
        $('head').prepend($('<link rel="stylesheet" type="text/css" />').attr('href', `${frontEndUrl}/assets/metronic/libs/bootstrap/css/bootstrap${cssPostfix}.css`));

        //Metronic css fils
        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', `${frontEndUrl}/assets/metronic/global/css/components-md${cssPostfix}.css`));
        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', `${frontEndUrl}/assets/metronic/global/css/plugins-md${cssPostfix}.css`));
        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', `${frontEndUrl}/assets/metronic/admin/layout4/css/layout${cssPostfix}.css`));
        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', `${frontEndUrl}/assets/metronic/admin/layout4/css/themes/default${cssPostfix}.css`));
        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', 'https://cdn.datatables.net/buttons/1.5.1/css/buttons.dataTables.min.css'));


        return $.Deferred().resolve();
    }

    private static loadLocalizedScripts(frontEndUrl: string): JQueryPromise<any> {
        if (!abp.session.userId) {
            return $.Deferred().resolve();
        }

        let currentCulture = abp.localization.currentLanguage.name;
        let isDefaultLanguage = abp.localization.currentLanguage.isDefault;

        let jTable = `${frontEndUrl}/assets/temp/localization/jtable/jquery.jtable.{0}.js`;
        let bootstrapSelect = `${frontEndUrl}/assets/temp/localization/bootstrap-select/defaults-{0}.js`;
        let jqueryTimeago = `${frontEndUrl}/assets/temp/localization/jquery-timeago/jquery.timeago.{0}.js`;

        return $.when(
            (!isDefaultLanguage ? jQuery.getScript(abp.utils.formatString(jTable, currentCulture)) : $.Deferred().resolve()),
            jQuery.getScript(abp.utils.formatString(bootstrapSelect, LocalizedResourcesHelper.findBootstrapSelectLocalization(currentCulture))),
            jQuery.getScript(abp.utils.formatString(jqueryTimeago, currentCulture))
        );
    }

    private static findBootstrapSelectLocalization(currentCulture: string): string {
        let supportedCultures = ["ar_AR",
            "bg_BG",
            "cs_CZ",
            "da_DK",
            "de_DE",
            "en_US",
            "es_CL",
            "eu",
            "fa_IR",
            "fi_FI",
            "fr_FR",
            "hu_HU",
            "id_ID",
            "it_IT",
            "ko_KR",
            "nb_NO",
            "nl_NL",
            "pl_PL",
            "pt_BR",
            "pt_PT",
            "ro_RO",
            "ru_RU",
            "sk_SK",
            "sl_SL",
            "sv_SE",
            "tr_TR",
            "ua_UA",
            "zh_CN",
            "zh_TW"];

        let foundCultures = supportedCultures.filter(sc => sc.indexOf(currentCulture) === 0);
        if (foundCultures && foundCultures.length > 0) {
            return foundCultures[0];
        }

        return 'en_US';
    }
}
